import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getApprovalWorkflows, deleteApprovalWorkflow } from "../../../actions/approvalWorkflow";
import { getCompany } from "../../../actions/company";
import Modal from "../../common/Modal/Modal";
import ApprovalWorkflowEditModal from "./ApprovalWorkflowEditModal";

export default function ApprovalWorkflowList() {
    const dispatch = useDispatch();

    const workflows = useSelector(state => state.approvalWorkflow.workflows);
    const company = useSelector(state => state.company.company);
    const isCompanyAdmin = useSelector(state => state.auth.user.croles && state.auth.user.croles["Company Admin"]);

    const [deletingWorkflow, setDeletingWorkflow] = useState(null);
    const [editingWorkflowUuid, setEditingWorkflowUuid] = useState(null);

    useEffect(() => {
        dispatch(getCompany());
        dispatch(getApprovalWorkflows());
    }, [dispatch]);

    const handleDelete = () => {
        dispatch(deleteApprovalWorkflow(deletingWorkflow.uuid));
        setDeletingWorkflow(null);
    };

    //company tier isn't known yet -- render nothing rather than flashing the Enterprise-only management UI by default
    if (!company.uuid) {
        return <></>;
    }

    //Basic-tier companies only ever use the 2 global templates -- no template management for them
    if (company.is_basic) {
        return (
            <div className="gap-below-s settings">
                <h4 className="content1 multiline light-black">Custom Approval Workflows are available on the Enterprise plan. Your contracts use the standard &quot;1 Approval Level&quot; / &quot;2 Approval Levels&quot; templates.</h4>
            </div>
        );
    }

    const globalWorkflows = workflows.filter(w => !w.fk_company);
    const companyWorkflows = workflows.filter(w => w.fk_company);

    return (
        <div className="gap-below-s settings">
            <div className="subhead-wrapper flex-row space-btwn">
                <h2 className="title2 heavy iblock gap-right-xs">Approval Workflows</h2>
                {isCompanyAdmin &&
                    <button type="button" className="btn pri iblock mini" onClick={() => setEditingWorkflowUuid("new")}>New Approval Workflow</button>
                }
            </div>
            <div className="table-wrapper">
                <div className="grid">
                    <div className="grid-child" style={{ gridColumn: "span 4" }}>
                        <h3 className="content2 heavy-grey gap-below-xxs">Standard Approval Workflows</h3>
                        {globalWorkflows.map(w => (
                            <h4 key={w.uuid} className="content1 multiline light-black gap-below-xs">{w.name}</h4>
                        ))}

                        <h3 className="content2 heavy-grey gap-below-xxs gap-above-m">Your Approval Workflows</h3>
                        {companyWorkflows.length < 1 && <h4 className="content1 multiline light">No custom Approval Workflows yet.</h4>}
                        {companyWorkflows.map(w => (
                            <div key={w.uuid} className="flex-row space-btwn gap-below-xxs">
                                <h4 className="content1 multiline light-black">
                                    {isCompanyAdmin
                                        ? <a onClick={() => setEditingWorkflowUuid(w.uuid)}>{w.name}</a>
                                        : w.name
                                    }
                                </h4>
                                {isCompanyAdmin &&
                                    <button type="button" className="btn ter mini iblock" onClick={() => setDeletingWorkflow(w)}>Delete</button>
                                }
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {deletingWorkflow &&
            <Modal blurBack={true} hasCloseButton={true} handleClose={() => setDeletingWorkflow(null)} >
                <div className="flex-column space-btwn flex1 w100" >
                    {/* Modal renders its own slogan as a direct flex child of .modal (which centers it),
                        but wraps props.children in a plain, non-flex "w100" div -- so the .slogan class's
                        width:80% would just left-align here instead of centering. Overriding to 100% width
                        lets text-align:center do the centering the same way the real slogan gets it. */}
                    <p className="slogan g5-text gap-below-m" style={{ width: "100%" }}>
                        Delete &quot;{deletingWorkflow.name}&quot;? Contracts already using it are not affected.
                    </p>
                    <div className="flex-row ">
                        <button className="iblock btn expand pri gap-right-xs" onClick={handleDelete} >Delete</button>
                        <button className="iblock btn expand sec" onClick={() => setDeletingWorkflow(null)} >Cancel</button>
                    </div>
                </div>
            </Modal>}

            {editingWorkflowUuid &&
            <ApprovalWorkflowEditModal
                uuid={editingWorkflowUuid}
                onClose={() => setEditingWorkflowUuid(null)}
                onSaved={() => {
                    setEditingWorkflowUuid(null);
                    dispatch(getApprovalWorkflows());
                }}
            />}
        </div>
    );
}
